const API = process.env.REACT_APP_API || 'api';

export { API as default };
